import React from 'react';
import { cn } from '../../../lib/cn';
import { Chevron, AppliedChip } from '../atoms';

/**
 * DrillRow, the 48px disclosure row into a sub-panel.
 *
 * CSS selector: `mobile/molecules.css` `.ds-drill-row`, with
 * `.ds-drill-row__label` and `.ds-drill-row__value`.
 *
 * Doctrine: drilling in is a command, so this renders a real `<button>` and
 * pairs with an ink `<AppliedChip>` count rather than an accent one. The
 * trailing `<Chevron>` is the muted disclosure glyph shared by every row in the
 * track.
 *
 * There is no `--last` modifier and none is invented here. The CSS drops the
 * hairline on `:last-of-type`, so render drill rows as siblings and the last
 * one loses its border on its own.
 */
export const DrillRow = React.forwardRef(function DrillRow(
  { className, label, value, count, type = 'button', ...rest },
  ref,
) {
  return (
    <button ref={ref} type={type} className={cn('ds-drill-row', className)} {...rest}>
      <span className="ds-drill-row__label">{label}</span>
      {value === undefined ? null : <span className="ds-drill-row__value">{value}</span>}
      {count === undefined ? null : <AppliedChip>{count}</AppliedChip>}
      <Chevron width={16} height={16} />
    </button>
  );
});

export default DrillRow;
